import Vue from 'vue';
import Vuex from 'vuex';
import addressModule from './modules/address';
import appModule from './modules/app';
import authModule from './modules/auth';
import cartModule from './modules/cart';
import estimateModule from './modules/estimate';
import recentlyViewed from './modules/recentlyViewed';
import snackBar from './modules/snackbar';
import wishlistModule from './modules/wishlist';
import followModule from './modules/follow';
import fileboxModule from './modules/filebox';
import guideModule from './modules/guide';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        app: appModule,
        auth: authModule,
        address: addressModule,
        wishlist: wishlistModule,
        filebox: fileboxModule,
        follow: followModule,
        cart: cartModule,
        estimate: estimateModule,
        guide: guideModule,
        snackbar: snackBar,
        recentlyViewed: recentlyViewed,
    },
});

export default store;
